import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import axios from "axios";
import NumberToPersianWord from "number_to_persian_word";
import GetPrice from "../Functions/GetPrice";
import authHeader from "../Services/auth-header";
// import CartInfo from "../Components/CartInfo";
import { refreshToken } from "../Services/auth.service";
import { CartUpdatedTrue, LOGIN, LOGOUT } from "../Actions/types";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { convertToPersian, NumToFa, RangeToFa } from "../Functions/TextTransform";
import { Accordion, AccordionContext, useAccordionButton } from "react-bootstrap";
import { CapitalizeAllWords } from "../Functions/TextTransform";
import RenderSideCart from "../Components/RenderSideCart";
import { useMediaQuery } from "react-responsive";
import UserProjects from "../Static Files/UserProjects.json";

import { baseURLGetFavorites, baseURLDeleteFavorite, baseURLAddProduct, baseURLFreeShipping, imgUrl } from "../config/api";
function Favorite() {
  const { t } = useTranslation();
  const location = useLocation();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    isLoggedIn,
    isRegistered,
    user,
    showLogin,
    cartUpdated,
    mainCart,
    sideCartPrice,
  } = useSelector((state) => state.auth);

  const [modals, setModals] = useState({});
  const [userFavorites, setUserFavorites] = useState([]);
  const [addingLoading, setAddingLoading] = useState(false);
  const [removingLoading, setRemovingLoading] = useState(false);
  const [firstFetch, setFirstFetch] = useState(true);

  const [sideCartObjects, setSideCartObjects] = useState({});
  const [cartCount, setCartCount] = useState(0);
  const [freeShipPrice, setFreeShipPrice] = useState(0);

  const productRef = useRef({});

  function getFavorites() {
    axios
      .get(baseURLGetFavorites, {
        headers: authHeader(),
      })
      .then((response) => {
        setUserFavorites(response.data || []);
        setFirstFetch(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              getFavorites();
            } else {
              // navigate("/" + pageLanguage);
            }
          });
        } else {
          setUserFavorites([]);
          setFirstFetch(false);
        }
      });
  }

  function modalHandleClose(modalName) {
    let tempModals = JSON.parse(JSON.stringify(modals));
    tempModals[modalName] = false;
    setModals(tempModals);
  }

  function modalHandleShow(modalName) {
    let tempModals = JSON.parse(JSON.stringify(modals));
    tempModals[modalName] = true;
    setModals(tempModals);
  }

  function addProjectToBag(product) {
    axios
      .post(
        baseURLAddProduct,
        {},
        {
          headers: authHeader(),
          params: {
            productId: product["ProductId"],
            hasLining: product["HasLining"],
            count: 1,
          },
        }
      )
      .then((response) => {
        setSideCartObjects(response.data || {});
        setCartCount(response.data?.CartDetails?.length || 0);
        modalHandleShow("cart_modal");
        axios
          .get(baseURLFreeShipping)
          .then((response) => {
            setFreeShipPrice(response.data);
          })
          .catch((err) => {
            console.log(err);
          });
        setAddingLoading(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              addProjectToBag(product);
            } else {
              navigate("/" + pageLanguage);
            }
          });
        } else {
          setAddingLoading(false);
        }
      });
  }

  function removeProject(id) {
    axios
      .delete(baseURLDeleteFavorite, {
        params: {
          id: id,
        },
        headers: authHeader(),
      })
      .then((response) => {
        // getFavorites();
        setUserFavorites(response.data || []);
        setRemovingLoading(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              removeProject(id);
            } else {
              navigate("/" + pageLanguage);
            }
          });
        } else {
          setRemovingLoading(false);
        }
      });
  }

  useEffect(() => {
    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
    } else if (pageLanguage !== "") {
      getFavorites();
    }
  }, [location.pathname, pageLanguage]);

  return (
    <div
      className={`Favorite_page_container ${pageLanguage === "fa" ? "font_farsi" : "font_en"} ${
        location.pathname.split("/")[2] === "Favorites" ? "independent_favorite_container" : ""
      }`}
    >
      <h1 className="Account_settings_section_title">
        {t("FAVORITES")}{" "}
        {userFavorites.length > 0 &&
          `(${
            pageLanguage === "fa"
              ? NumberToPersianWord.convertEnToPe(`${userFavorites.length}`)
              : userFavorites.length
          })`}
      </h1>
      <div className="Favorite_container">
        <div className="basket_flex">
          <div className="basket_section">
            <div className="drapery_basket">
              <ul className="favorite_items">
                {!firstFetch && userFavorites.length === 0 && (
                  <h1 key={1} className="no_project">
                    You don't have any favorite products yet.
                  </h1>
                )}
                {userFavorites.length > 0 &&
                  userFavorites.map((obj, index) => {
                    let ProductId = obj["ProductId"];
                    let FavoriteProductId = obj["FavoriteProductId"];
                    let PhotoUrl = obj["PhotoUrl"];
                    let ProductEnName = obj["ProductEnName"];
                    let ProductName = obj["ProductName"];
                    let SewingModelEnName = obj["SewingModelEnName"];
                    let SewingModelName = obj["SewingModelName"];
                    let IsComplete = obj["IsComplete"];
                    return (
                      <li
                        className="favorite_item"
                        key={index}
                        ref={(ref) => (productRef.current[ProductId] = ref)}
                      >
                        <div className="favorite_item_container">
                          <div className="favorite_item_img_container">
                            <Link
                              to={{
                                pathname:
                                  "/" +
                                  pageLanguage +
                                  "/" +
                                  obj["RelatedPage"] +
                                  "/" +
                                  obj["PageName"] +
                                  "/" +
                                  obj["ProductGroupId"] +
                                  "/" +
                                  obj["DesignCode"],
                                search: `Product=${obj["ProductId"]}&C=${IsComplete ? "1" : "0"}`,
                              }}
                            >
                              <img
                                src={imgUrl(PhotoUrl)}
                                alt=""
                                className="img-fluid favorite_item_img"
                              />
                            </Link>
                          </div>
                          <div className="favorite_item_desc">
                            <h1 className="favorite_item_title">
                              {pageLanguage === "fa" ? ProductName : ProductEnName}{" "}
                              {pageLanguage === "fa" ? SewingModelName : SewingModelEnName}
                            </h1>
                          </div>
                          <div className="favorite_item_buttons">
                            {!IsComplete && (
                              <Link
                                className="btn favorite_item_button"
                                to={{
                                  pathname:
                                    "/" +
                                    pageLanguage +
                                    "/" +
                                    obj["RelatedPage"] +
                                    "/" +
                                    obj["PageName"] +
                                    "/" +
                                    obj["ProductGroupId"] +
                                    "/" +
                                    obj["DesignCode"],
                                  search: `Product=${obj["ProductId"]}&C=${IsComplete ? "1" : "0"}`,
                                }}
                              >
                                {t("View Details")}
                              </Link>
                            )}
                            {IsComplete && (
                              <button
                                className="btn favorite_item_button"
                                disabled={addingLoading || removingLoading}
                                onClick={() => {
                                  setAddingLoading(true);
                                  addProjectToBag(obj);
                                }}
                              >
                                {t("ADD TO BAG")}
                              </button>
                            )}
                            <button
                              className="btn_white favorite_item_button"
                              disabled={addingLoading || removingLoading}
                              onClick={() => {
                                setRemovingLoading(true);
                                removeProject(FavoriteProductId);
                              }}
                            >
                              {t("Remove")}
                            </button>
                          </div>
                        </div>
                      </li>
                    );
                  })}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["cart_modal"] === undefined ? false : modals["cart_modal"]}
        onHide={() => {
          modalHandleClose("cart_modal");
        }}
        id="cart_modal"
      >
        <div className="custom_cart_header_desc">{`${
          freeShipPrice - sideCartPrice > 0
            ? `${t("cart_agree_free_ship1")}${
                pageLanguage === "fa"
                  ? NumberToPersianWord.convertEnToPe(
                      `${GetPrice(
                        freeShipPrice - sideCartPrice,
                        pageLanguage,
                        t("TOMANS"),
                        isTabletOrMobile
                      )}`
                    )
                  : GetPrice(
                      freeShipPrice - sideCartPrice,
                      pageLanguage,
                      t("TOMANS"),
                      isTabletOrMobile
                    )
              }${t("cart_agree_free_ship2")}`
            : `${t("cart_agree_free_ship")}`
        }`}</div>
        <Modal.Header>
          <span className="custom_cart_title">
            {t("My Bag")}{" "}
            <h3>
              (
              {pageLanguage === "fa"
                ? NumberToPersianWord.convertEnToPe(`${cartCount}`)
                : cartCount}
              )
            </h3>
          </span>

          <button
            className="custom_cart_close"
            onClick={() => {
              modalHandleClose("cart_modal");
              sessionStorage.clear();
              // navigate("/" + pageLanguage);
            }}
          >
            {t("CONTINUE SHOPPING")}
          </button>
        </Modal.Header>
        <Modal.Body>
          <RenderSideCart cartObjects={sideCartObjects} />
        </Modal.Body>
        <Modal.Footer>
          <div className="go_to_checkout">
            <div className="checkout_button_section small_checkout_button_section">
              <span className="checkout_payment_price_detail payment_price_detail">
                <h3>11-{t("SUBTOTAL")}</h3>
                <h4>{GetPrice(sideCartPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}</h4>
              </span>
              <Link className="basket_checkout btn" to={"/" + pageLanguage + "/Basket"}>
                {t("CHECKOUT")}
              </Link>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Favorite;
